module.exports = __webpack_public_path__ + "img/84_21.a7acf8ce.png";